export function startHero() {
    // button that reveals promocode form
    const havePromocodeBtn = document.getElementById('promocode-proposal');
    const promocodeBlock = document.querySelector('.promocode-block');
    const promocodeText = document.querySelector('.links-form--wide');

    // promocode form and its elements
    const promocodeForm = document.getElementById('promocode-form');
    const checkPromocodeButton = promocodeForm.querySelector('button');
    const checkPromocodeInput = promocodeForm.querySelector('input');

    // promocode check results
    const promocodeCheckError = document.getElementById('promocode-check-error');
    const promocodeCheckSuccess = document.getElementById('promocode-check-success');

    // input in the original form that should contain a VALID, checked promocode (or nothing)
    const promocodeInput = document.getElementById('promocode');

    const setLoading = isLoading => {
        if (isLoading) {
            checkPromocodeButton.setAttribute('aria-busy', true);
            checkPromocodeButton.setAttribute('tabindex', -1);
            checkPromocodeInput.setAttribute('aria-busy', true);
            checkPromocodeInput.setAttribute('disabled', true);
            return
        }

        checkPromocodeButton.removeAttribute('aria-busy');
        checkPromocodeButton.removeAttribute('tabindex');
        checkPromocodeInput.removeAttribute('aria-busy');
        checkPromocodeInput.removeAttribute('disabled');
    }

    const showError = error => {
        promocodeCheckError.innerHTML = error
        promocodeCheckError.classList.add('promocode--message--show')
    }
    const resetErrors = () => {
        promocodeCheckError.innerHTML = ''
        promocodeCheckError.classList.remove('promocode--message--show')
    }

    // step 1
    const revealForm = () => {
        havePromocodeBtn.remove();
        promocodeBlock.classList.add('promo--shown');
        promocodeForm.querySelectorAll('input, button').forEach(
            el => el.removeAttribute('tabindex')
        );
    }

    const applyBonus = (sum, code) => {
        promocodeInput.value = code
        promocodeForm.removeEventListener('submit', checkEnteredPromocode);
        promocodeForm.remove()
        promocodeText.remove()
        promocodeCheckSuccess.classList.add('promocode--message--show')
        promocodeCheckSuccess.innerHTML = `Success! You got your $${sum}!`
    }

    // step 2
    const checkEnteredPromocode = e => {
        e.preventDefault();
        const promocode = e.target.promocode.value;

        resetErrors()

        // check promocode
        const body = new URLSearchParams();
        body.append('code', promocode);

        setLoading(true)

        fetch('/ajax/checkPromocodeAll', {
            method: 'post',
            body,
        }).then(res => res.json()).then(data => {
            setLoading(false)
            
            if (data.status === 1) {
                applyBonus(data.sum, promocode)
            } else {
                showError(`Sorry, this promo code is invalid.`)
            }
        }).catch(() => {
            setLoading(false)
            showError(`Something’s wrong. Please, try again later.`)
        })
    }

    havePromocodeBtn.addEventListener('click', revealForm, {
        once: true
    });

    promocodeForm.addEventListener('submit', checkEnteredPromocode);
}